/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

import DEIPageDatepicker from '../DEIPageDatepicker/DEIPageDatepicker';
import DEIPageLegend from '../DEIPageLegend/DEIPageLegend';

import {
  DEIPageClusterChartLegendDIV,
} from './DEIPageClusterChartLegend.styles';

const DEIPageClusterChartLegend = ({
  activeDateTitle,
  colors = [],
  dates = [],
  footnote,
  onHoverType,
  onSelectDate,
  title,
  types = [],
}) => (
    <DEIPageClusterChartLegendDIV>
      <h3>{title}</h3>
      <DEIPageDatepicker
        activeDateTitle={activeDateTitle}
        dates={dates}
        onSelectDate={onSelectDate}
      />
      <DEIPageLegend
        colors={colors}
        onHoverType={onHoverType}
        types={types}
      />
      {footnote && <p>{footnote}</p>}
    </DEIPageClusterChartLegendDIV>
  );

export default DEIPageClusterChartLegend;